import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 350px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;

    @media (max-width: 450px) {
        bottom: 200px;
    }
`;

export const ModalContainer = styled.div`
    background-color: #1a1a2e;
    border: 2px solid #FFD700;
    border-radius: 12px;
    max-width: 500px;
    width: 95%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    animation: slideIn 0.3s ease-out;

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #FFD700;
`;

export const ModalTitle = styled.h2`
    color: #FFD700;
    margin: 0;
    font-size: clamp(16px, 4vw, 20px);
    font-weight: bold;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: #FFD700;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover {
        background-color: rgba(255, 215, 0, 0.1);
        color: #FFF;
    }

    &:active {
        background-color: rgba(255, 215, 0, 0.2);
    }
`;

export const ModalContent = styled.div`
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;

    @media (max-width: 450px) {
        > div {
            flex-direction: column !important;
            gap: 10px !important;
        }
    }

    input {
        background-color: #0f3460;
        border: 1px solid #FFD700;
        color: white;
        padding: 10px;
        border-radius: 6px;
        font-size: 14px;
        transition: all 0.3s ease;

        &:focus {
            outline: none;
            background-color: #164e63;
            box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
        }

        &::placeholder {
            color: rgba(255, 255, 255, 0.5);
        }

        &:disabled {
            background-color: #1a3a3a;
            border-color: #999;
            color: #999;
            cursor: not-allowed;
        }
    }

    span {
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .listaFlexCol {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
`;

export const ModalFooter = styled.div`
    display: flex;
    gap: 10px;
    padding: 10px;
    border-top: 1px solid #FFD700;
    justify-content: flex-end;
`;

export const ButtonCancel = styled.button`
    padding: 10px 20px;
    background-color: #333;
    border: 1px solid #666;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
        background-color: #444;
        border-color: #888;
    }

    &:active {
        background-color: #222;
    }
`;

export const ButtonAdd = styled.button`
    padding: 10px 20px;
    background-color: #FFD700;
    border: 1px solid #FFD700;
    color: #000;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
        background-color: #FFC700;
        box-shadow: 0 0 15px rgba(255, 215, 0, 0.3);
    }

    &:active {
        background-color: #FFB700;
    }

    &:disabled {
        background-color: #999;
        cursor: not-allowed;
        border-color: #666;
    }
`;
